export enum SteppedLoaderImageKeys {
  DOCS = 'docs',
  CAR = 'car',
  PRICE = 'price',
  SHIELD = 'shield',
}
